exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".files[data-v-386b1bb9]{padding:1rem;height:100%;background-color:#fff}form[data-v-386b1bb9]{padding-top:1rem;margin-top:1rem;border-top:1px solid #ddd}", ""]);

// exports
